<template>
  <el-dialog v-dialog-drag='{width: "80vw", height: "90vh", marginTop: "5vh", isFullscreen: false}'
             :title='dialogTitle' :visible.sync='dialogVisible' :close-on-click-modal='false'
             @close='dialogClose'>
    <div class='mainContainer'>
      <div class='nav'>
        <el-form :model='searchForm' label-width='100px' :inline='true'>
          <el-form-item label='考核模块：'>
            {{ moduleName }}
          </el-form-item>
          <el-form-item>
            <el-button size='small' class='searchBtn' @click='btnClick("add")'>新增
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <el-row>
        <el-col :span='24' style='text-align: end;font-size: 14px!important;' class='exportButton'>
          <div style='display: flex;justify-content: flex-end;'>
            <span @click='exportData'>导出数据</span>
          </div>
        </el-col>
      </el-row>
      <div class='content'>
        <el-table
          ref='registerTable'
          row-key='id'
          v-loading='tableLoading'
          :data='tableData'
          style='width: 100%'
          max-height='700px'
          border
          :header-cell-style='headerCellStyle'
          :span-method='objectSpanMethod'>
          <el-table-column type='index' align='center' min-width='50' />
          <el-table-column label='考核模块' prop='moduleName' align='center' width='150' />
          <el-table-column label='考核指标' prop='examineTarget' align='center'
                           :formatter='examineTargetFormat' width='150' />
          <el-table-column label='指标与权重' prop='targetWeight' align='center' width='180' />
          <el-table-column label='分值' prop='score' align='center' />
          <el-table-column label='计算公式' prop='calculationFormula' align='center' width='400' />
          <el-table-column label='目标值' prop='targetValue' align='center' width='100' />
          <el-table-column label='评分标准' prop='scoringCriteriaStr' align='left' width='360'>
            <template slot-scope='scope'>
              <div v-html='scope.row.scoringCriteriaStr' />
            </template>
          </el-table-column>
          <el-table-column label='数据提供部门' prop='provideDepartment' align='center' width='150' />
          <el-table-column label='考核周期' prop='examineDate' align='center' />
          <el-table-column label='考核部门' prop='examineDepartment' align='center' width='150' />
          <el-table-column label='操作' width='205' align='center' fixed='right'>
            <template slot-scope='scope'>
              <el-button size='mini' class='searchBtn' type='primary'
                         @click='btnClick("info",scope.row)'>详情
              </el-button>
              <el-button size='mini' class='yellow-bg' type='primary'
                         @click='btnClick("edit",scope.row)'>修改
              </el-button>
              <el-button v-if='scope.row.isUpdate === "0"' size='mini' type='info'
                         @click='btnClick("delete",scope.row)'>删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 新增/编辑 -->
      <indicator-management-form ref='indicatorManagementFormRef' @searchBtn='getDetails' />
      <!-- 详情 -->
      <indicator-management-info ref='indicatorManagementInfoRef' />
    </div>
  </el-dialog>
</template>

<script>
  import IndicatorManagementForm from './indicatorManagement-components/form';
  import IndicatorManagementInfo from './indicatorManagement-components/info';
  import { supplierPortWarehouseSettlementList } from '@/service/warehouse';
  import { getSessionStore } from '@/config/mUtils';
  import { baseUrl } from '@/config/env';
  import { indicatorSettingsDelete, indicatorSettingsInfo } from '@/service/supplierAssessment';

  export default {
    name: 'indicatorManagement',
    components: {
      IndicatorManagementForm,
      IndicatorManagementInfo,
    },
    data() {
      return {
        dialogTitle: '指标管理',
        moduleName: '',
        dialogVisible: false,
        searchForm: {
          id: '',
        },
        defaultSearchForm: {},
        tableLoading: false,
        tableData: [],
        headerCellStyle: {
          'color': '#3B3B3B',
          'font-size': '13px',
          'height': '48px',
          'background': '#E8E8E8',
        },
      };
    },
    mounted() {
      this.defaultSearchForm = JSON.parse(JSON.stringify(this.searchForm));
    },
    methods: {
      examineTargetFormat(r, c, cellValue) {
        switch (cellValue) {
          case '0':
            return 'KPI指标';
          case '1':
            return '物流综合服务能力';
        }
      },
      // 导出数据
      exportData() {
        let token = getSessionStore('token');
        window.location.href = `${baseUrl}/platform/supplierMonthExamineManage/exportModuleDetailList/${this.searchForm.id}?access_token=${token}`;
      },
      dialogOpen(row) {
        this.dialogVisible = true;
        this.moduleName = row.moduleName;
        this.searchForm.id = row.id;
        this.getDetails();
      },
      async getDetails() {
        this.tableLoading = true;
        const {
          status,
          message,
          data,
        } = await indicatorSettingsInfo(this.searchForm.id);
        this.tableLoading = false;
        if (status !== 0) return this.$message.warning(message);
        this.tableData = data;
      },
      dialogClose() {
        this.dialogVisible = false;
        this.$emit('getTableData');
      },
      /**
       * 按钮点击
       * @param str 必填 判断标识
       * @param row 非必填 行数据
       */
      btnClick(str, row) {
        switch (str) {
          case 'add':
            this.$refs.indicatorManagementFormRef.dialogOpen('新增考核指标', this.searchForm.id);
            break;
          case 'edit':
            this.$refs.indicatorManagementFormRef.dialogOpen('修改考核指标', this.searchForm.id, row);
            break;
          case 'info':
            this.$refs.indicatorManagementInfoRef.dialogOpen(row);
            break;
          case 'delete':
            this.deleteData(row.id);
            break;
        }
      },
      /**
       * 删除
       * @param id 当前选中数据 id
       */
      deleteData(id) {
        this.$confirm('确认删除当前数据？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(async () => {
            const {
              status,
              message,
            } = await indicatorSettingsDelete(id);
            if (status !== 0) return this.$message.warning(message);
            this.$message.success(message);
            await this.getDetails();
          });
      },
      // 合并相同列
      objectSpanMethod({
                         row,
                         column,
                         rowIndex,
                         columnIndex,
                       }) {
        // data ：需要修改的列数和列的属性 第一列从0开始
        const data = [
          {
            columnIndex: 1,
            value: 'moduleName',
          },
          {
            columnIndex: 2,
            value: 'examineTarget',
          },
        ];
        for (let index = 0; index < data.length; index++) {
          if (columnIndex === data[index].columnIndex) {
            const _row = this.filterData(this.tableData, data[index].value)[rowIndex];
            const _col = _row > 0 ? 1 : 0;
            return {
              rowspan: _row,
              colspan: _col,
            };
          }
        }
      },
      // 根据是否有相同数据返回一个如[2,0,3,0,0]格式的数组(公共的)
      filterData(arr, value) {
        let spanOneArr = [];
        let concatOne = 0;
        arr.forEach((item, index) => {
          if (index === 0) {
            spanOneArr.push(1);
          } else {
            // name 修改
            if (item[value] === arr[index - 1][value]) {
              spanOneArr[concatOne] += 1;
              spanOneArr.push(0);
            } else {
              spanOneArr.push(1);
              concatOne = index;
            }
          }
        });
        return spanOneArr;
      },
    },
  };
</script>


<style lang='scss' scoped>
  .mainContainer {
    width: 100%;
    padding: 20px 15px 0 15px;
    background-color: #fff;

    .nav {
      width: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      &Btn {
        display: flex;
        align-items: center;
        margin-bottom: 5px;
      }
    }

    .content {
      .paginationContainer {
        margin-right: auto;
        display: flex;
        align-items: center;
        margin-top: 10px;

        span {
          font-size: 13px;
        }
      }
    }
  }
</style>
